import React from 'react';
import { Info, SearchX, ArrowRight } from './icons';
import { SyntaxItem } from './SyntaxItem';

export function SyntaxContent({
  category,
  searchQuery,
  searchResults,
  onSelectCategory,
  onClearSearch,
}) {
  const isSearching = searchQuery && searchQuery.trim() !== '';

  if (isSearching) {
    if (!searchResults || searchResults.length === 0) {
      return (
        <div className="syntax-empty-search-state">
          <div className="syntax-empty-search-icon">
            <SearchX size={40} />
          </div>
          <h4 className="syntax-empty-search-title">No syntax matches found</h4>
          <p className="syntax-empty-search-text">
            No syntax rules match "{searchQuery}". Try searching for terms like "borrower", "exists", "AND", "OR", "optional", "table", "clear space", or "comparison".
          </p>
          <button
            type="button"
            className="syntax-clear-search-action"
            onClick={onClearSearch}
          >
            Clear Search
          </button>
        </div>
      );
    }

    return (
      <div className="syntax-search-results-pane">
        <div className="syntax-search-summary-bar">
          Found <strong>{searchResults.length}</strong> matching {searchResults.length === 1 ? 'item' : 'items'} for "{searchQuery}"
        </div>

        <div className="syntax-search-cards-list">
          {searchResults.map((match) => (
            <div
              key={`${match.categoryId}-${match.item.id}`}
              className="syntax-search-result-card"
              onClick={() => onSelectCategory(match.categoryId, match.item.id)}
            >
              <div className="syntax-search-card-header">
                <div className="syntax-search-card-badges">
                  <span className="syntax-search-cat-badge">{match.categoryName}</span>
                  {match.item.badge && (
                    <span className="syntax-search-item-badge">{match.item.badge}</span>
                  )}
                </div>
                <div className="syntax-search-jump-action">
                  <span>View</span>
                  <ArrowRight size={13} />
                </div>
              </div>

              <h4 className="syntax-search-card-title">{match.item.title}</h4>
              <p className="syntax-search-card-desc">{match.item.meaning}</p>

              <div className="syntax-code-box syntax-search-code-preview">
                <code>{match.item.syntax}</code>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!category) return null;

  return (
    <div className="syntax-doc-pane">
      {/* Category Heading & Description */}
      <header className="syntax-doc-header">
        <h2 className="syntax-doc-title">{category.name}</h2>
        <p className="syntax-doc-description">{category.description}</p>
      </header>

      {/* Render All Detailed Documentation Items */}
      <div className="syntax-items-list">
        {category.items && category.items.length > 0 ? (
          category.items.map((item) => (
            <SyntaxItem key={item.id} item={item} />
          ))
        ) : (
          <p className="text-muted">No documentation items available.</p>
        )}
      </div>

      {/* Category Level Tip Banner */}
      {category.tip && (
        <div className="syntax-tip-banner">
          <div className="syntax-tip-icon-wrapper">
            <Info size={18} />
          </div>
          <div className="syntax-tip-content">
            <h4 className="syntax-tip-heading">Pro Tip</h4>
            <p className="syntax-tip-text">{category.tip}</p>
          </div>
        </div>
      )}
    </div>
  );
}
